<div
  role="radiogroup"
  class="ms-xlarge-b"
  [attr.aria-labelledby]="'radio-group-label-' + id"
  [attr.id]="'radio-group-' + id"
>
  <span class="font-body-1 light-type nordic-blue-900-text" [attr.id]="'radio-group-label-' + id">
    {{ translationPrefix + '.label' | finLocalization }}
    <span *ngIf="required"> *</span>
  </span>

  <ng-content></ng-content>
</div>
